export default class MonitoringTestRunsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = window.location.href.split('?')[0];
      let params = {};
      let test_id = $('#monitoring_test_runs_table').attr('data-filters-test-id');
      if (typeof test_id !== 'undefined') {params['test_id'] = test_id}
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('#search_tests').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#monitoring_test_runs_table').attr('data-filters-test-id', suggestion.test_id);
      reloadWithSelectedParams();
      $(this).blur();
    });

  }


}